import { Close } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select } from '@mui/material';
import React, { useEffect } from 'react'
import { getReasonCategory } from './constants/constant';
import ReasonSubreasonModuleEnum from '../../enums/ReasonSubreasonModuleEnum';
import { ActionTypeEnum } from '../../enums/ActionTypeEnum';
import ChefForPartyService from '../../services/ChefForPartyService';
import { useRefresh } from 'react-admin';

const chefForPartyService = new ChefForPartyService();
function UpdateOccasionDialog(props: any) {

    const [occasionType, setOccasionType] = React.useState<string>("");
    const [occasionList, setOccasionList] = React.useState<any[]>([]);
    const refresh = useRefresh();
    

    function handleClose() {
        props.callback(null);
    }

    async function updateOccasion() {
        if (occasionType) {
            let payload = {
                occasion: occasionType,
            };
            chefForPartyService.updateOccasion(props?.data?.id, payload).then((response: any) => {
                if (response) {
                    props.callback(null);
                    refresh();
                }
            }).catch((error: any) => {
                console.error("Error updating occasion:", error);
            });
        }
    }

    async function fetchOccasionList() {
        let sampleReasonSubReason = await getReasonCategory(ReasonSubreasonModuleEnum.CHEF_FOR_PARTY,ActionTypeEnum.OCCASION);
        setOccasionList(sampleReasonSubReason);   
    }

    useEffect(() => {
        if (props.open) {
            fetchOccasionList();
        }
    },[props.open]);

  return (
    <Dialog
            onClose={handleClose}
            open={props.open}
            scroll={"paper"}
            maxWidth="sm"
            fullWidth
        >
                <DialogTitle>Update Occasion</DialogTitle>
                <DialogContent>
                    <IconButton onClick={() => props.callback(null)} sx={{ position: 'absolute', top: 2, right: 5 }}> <Close /> </IconButton>
                
                <FormControl fullWidth>
                <InputLabel id="type-label">Occasion Type</InputLabel>
                    <Select
                            labelId="type"
                            id="type"
                            label="Occasion Type"
                            value={occasionType}
                            sx={{marginTop:"2rem"}}
                            onChange={(event: any) => {
                                setOccasionType(event.target.value);
                            }}
                        >
                            {occasionList.map((d: any) => (
                                <MenuItem key={d} value={d?.category}>
                                    {d?.category}
                                </MenuItem>
                            ))}
                        </Select>
                </FormControl>
                   
                </DialogContent>
                <DialogActions style={{ marginTop: "12px" }}>
                    <Button
                        variant="contained"
                        onClick={() => {
                            updateOccasion()
                        }}
                        size={"large"}
                    >
                        Submit
                    </Button>
                    <Button
                        variant="contained"
                        color={"error"}
                        onClick={() => {props.callback(null)}}
                        size={"large"}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
  )
}

export default UpdateOccasionDialog
